export const ModalTypes = {
  AddCardPost: 'AddCardPost',
  EditCardPost: 'EditCardPost',
  Unset: 'Unset',
} as const;
